var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
import {} from '@galigeo-store/galigeojs';
let SelectApiNodeInput = class SelectApiNodeInput extends LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
    }
    firstUpdated(_changedProperties) {
        this.fetchOptions();
        super.firstUpdated(_changedProperties);
    }
    fetchOptions() {
        if (!this.apiService || !this.input?.options_url) {
            console.warn('API service or options_url not provided');
            this.setOptions(this.input?.options || []);
            return;
        }
        this.apiService.get(this.input.options_url)
            .then(data => {
            const fetchedOptions = this.mapDataToOptions(data);
            if (fetchedOptions.length === 0) {
                this.setOptions([]);
                return;
            }
            this.reorderOptionsAndSetDefaultValue(fetchedOptions);
            this.setOptions(fetchedOptions);
            this.requestUpdate();
        })
            .catch(error => {
            console.error(`Error fetching options from ${this.input.options_url}:`, error);
            this.setOptions([]);
        });
    }
    mapDataToOptions(data) {
        if (this.input.id_field == null || this.input.label_field == null) {
            console.warn('id_field or label_field not defined in input configuration');
            return [];
        }
        return data.map((d) => {
            const value = d[this.input.id_field];
            const label = d[this.input.label_field];
            return {
                value: value,
                label: String(label)
            };
        });
    }
    reorderOptionsAndSetDefaultValue(options) {
        const currentValue = this.input?.value;
        const matchingIndex = options.findIndex(option => option.value === currentValue);
        if (matchingIndex > 0) {
            // Move matching option to first position
            const matchingOption = options[matchingIndex];
            if (matchingOption) {
                options.splice(matchingIndex, 1);
                options.unshift(matchingOption);
            }
            this.input.value = matchingOption?.value;
        }
        else if (currentValue == null && options.length > 0) {
            // Set first option as default value if no value is set and field is not nullable
            if (!this.input?.nullable) {
                const firstOption = options[0];
                if (firstOption) {
                    this.input.value = firstOption.value;
                    this.dispatchEvent(new CustomEvent('node-input-change', {
                        detail: { key: this.key, input: this.input },
                        bubbles: true,
                        composed: true
                    }));
                }
            }
        }
    }
    setOptions(options) {
        this.options = this.input?.nullable
            ? [{ value: '', label: '---' }, ...options]
            : options;
    }
    onInputChange(event) {
        const firstOption = this.options[0];
        const selectElement = event.target;
        // Input value force keep it s type
        if (firstOption && typeof firstOption.value === 'number') {
            this.input.value = parseFloat(selectElement.value);
        }
        else {
            this.input.value = selectElement.value;
        }
        this.dispatchEvent(new CustomEvent('node-input-change', {
            detail: { input: this.input },
            bubbles: true,
            composed: true
        }));
    }
    // Refresh button handler
    refreshOptions() {
        this.fetchOptions();
    }
    render() {
        return html `
        <select-input
            .options=${this.options}
            .value=${this.input?.value ?? ''}
            @select-change=${this.onInputChange}
        ></select-input>
        <div class="margin"></div>
        <simple-button
            class="refresh-button"
            label="${CommonActions.refresh()}"
            primary
            size="small"
            variant="secondary"
            @button-click=${this.refreshOptions}
        ></simple-button>
    `;
    }
};
SelectApiNodeInput.styles = css `
      .select-node-input {
        width: 100%;
        padding: 6px 9px; /* Réduction de 25% */
        font-size: 10.5px; /* Réduction de 25% */
        border: 1px solid #ccc;
        border-radius: 3px; /* Réduction de 25% */
        box-sizing: border-box;
        transition: border-color 0.3s ease, box-shadow 0.3s ease;
        background-color: #fff;
        font-family: inherit;
      }

      .select-node-input:focus {
        border-color: #555ab9;
        box-shadow: 0 0 3px rgba(85, 90, 185, 0.5); /* Réduction de 25% */
        outline: none;
      }

      .margin {
          height: 6px; /* Réduction de 25% */
      }

      .refresh-button {
      }
    `;
__decorate([
    property({ type: String })
], SelectApiNodeInput.prototype, "key", void 0);
__decorate([
    property({ type: Object })
], SelectApiNodeInput.prototype, "input", void 0);
__decorate([
    property({ type: Object })
], SelectApiNodeInput.prototype, "apiService", void 0);
__decorate([
    state()
], SelectApiNodeInput.prototype, "options", void 0);
SelectApiNodeInput = __decorate([
    localized(),
    customElement('select-api-node-input')
], SelectApiNodeInput);
export { SelectApiNodeInput };
//# sourceMappingURL=SelectApiNodeInput.js.map